module.exports = __webpack_public_path__ + "img/c6.62fe3f1f.jpg";